import React, { Component } from 'react';
import { Form, Table, Button, Row, Col, Select, DatePicker, Space } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/report';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

class Statement extends Component {

    state = {
        startDate: null,
        endDate: null
    }
    onFinish = (values) => {
        this.props.onGet(values.agent, this.state.startDate, this.state.endDate, this.props.token);
    };

    onFinishFailed = (errorInfo) => {

    };
    handleAction = (reportId) => {
        this.props.onDetail(reportId, this.props.token);
        this.props.history.push("/reportDetail");
    }
    dateHandler = (value, dateString) => {
        this.setState(prevState => {
            return {
                ...prevState,
                startDate: dateString[0],
                endDate: dateString[1]
            }
        });
    }

    render() {
        const { RangePicker } = DatePicker;
        const { Option } = Select;
        let table = null;
        const agents = this.props.agents.map(agent => {
            return (
                <Option key={agent.id} value={agent.id}>{agent.name}</Option>
            );
        });
        const dataSource = [];
        if (this.props.statement) {
            this.props.statement.reportInfos.map(report => {
                let date = moment(report.reportDate)
                let { openingBalance, closingBalance } = report;
                date.locale('my');
                let item = {
                    ...report,
                    reportDate: date.format('lll'),
                    openingBalance: `${openingBalance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                    closingBalance: `${closingBalance}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                }
                dataSource.push(item);
                return '';
            });
        }
        const columns = [
            {
                title: 'Date',
                dataIndex: 'reportDate',
                key: 'reportDate',
                align:'center',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                align:'center',
            },
            {
                title: 'OpeningBalance',
                dataIndex: 'openingBalance',
                key: 'openingBalance',
                align: 'right'
            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                align: 'right',
                render: (text, record) => (
                    <Space size="middle">
                        <a onClick={() => this.handleAction(record.reportId)}>{`${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</a>
                    </Space>
                ),
            },
            {
                title: 'ClosingBalance',
                dataIndex: 'closingBalance',
                key: 'closingBalance',
                align: 'right'
            }
        ];
        if (dataSource.length > 0) {
            table = <Table dataSource={dataSource} columns={columns} bordered />;
        }
        return (
            <>
                <h1 style={{ fontSize: '24px' }}>Get Statement</h1>
                <Row justify="left" align="middle">
                    <Col lg={20} sm={20}>
                        <Form
                            name="basic"
                            layout="inline"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Form.Item
                                style={{ width: '200px' }}
                                label="Agent"
                                name="agent"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select agent',
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                >
                                    {agents}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="dates"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select dates',
                                    },
                                ]}
                            >
                                <RangePicker onChange={this.dateHandler} format="DD-MM-YYYY" />
                            </Form.Item>
                            <Form.Item >
                                <Button type="primary" htmlType="submit">
                                    Load
                            </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <br />
                <br />
                {table}
            </>
        );
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        agents: state.agents.agents,
        report: state.report.report,
        message: state.report.message,
        error: state.report.error,
        statement: state.report.statement,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onGet: (agentId, startDate, endDate, token) => dispatch(actions.getStatement(agentId, startDate, endDate, token)),
        onDetail: (reportId, token) => dispatch(actions.getReportDetail(reportId, token)),
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Statement));